<template>
  <v-dialog v-model="show" max-width="800" scrollable>
    <AHelpItem :data="data"></AHelpItem>
  </v-dialog>
</template>

<script>
import AHelpItem from "./AHelpItem";

var sampleschema = [
  {
    title: "How to Signin",
    body: [
      { type: "plain", data: "Enter username and password" },
      { type: "list", data: ["One", "Two"] },
      { type: "image", data: "/signin.jpg" },
      {
        type: "video",
        data: {
          poster: "//vjs.zencdn.net/v/oceans.png",
          mp4: "//vjs.zencdn.net/v/oceans.mp4",
          mebm: "",
          ogg: ""
        }
      },
      { type: "html", data: "<b>BOLD<b>" }
    ]
  }
];

export default {
  name: "AHelpDialog",
  components: {
    AHelpItem
  },
  data() {
    return {
      show: false,
      data: {}
    };
  },
  methods: {
    open(d) {
      this.show = true;
      this.data = d;
    }
  },
  watch: {
    show: function() {
      if (!this.show) this.data = {};
    }
  }
};
</script>